module.exports = __webpack_public_path__ + "img/Escuela.67bf0c2b.svg";